/*
  "Go to [n] Page" box in the numbered pagination.

  One delegated listener on document, registered once, so the snippet can be
  rendered several times on a page (or re-rendered by a filter update) without
  stacking handlers.
*/
(function () {
  if (window.__mPaginationGoto) return;
  window.__mPaginationGoto = true;

  function go(input) {
    var nav = input.closest('[data-pagination]');
    if (!nav) return;

    var last = parseInt(nav.getAttribute('data-last-page'), 10) || 1;
    var page = parseInt(input.value, 10);

    if (isNaN(page)) return;
    if (page < 1) page = 1;
    if (page > last) page = last;

    var base = nav.getAttribute('data-page-url');
    if (!base) return;

    window.location.href = base + page + (nav.getAttribute('data-anchor') || '');
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-goto-input]');
    if (!input) return;
    event.preventDefault();
    go(input);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-goto-input]');
    if (input) go(input);
  });
})();
